import { createRouter, createWebHistory } from "vue-router";
import HomePage from "../views/Home/HomePage.vue";
import CategoriesPage from "../views/CategoriesPage.vue";
import SubjectsPage from "../views/SubjectsPage.vue";
import ExplorePage from "../views/ExplorePage.vue";
import RankingsPage from "../views/RankingsPage.vue";
import LoginPage from "../views/LoginPage.vue";
import RegisterPage from "../views/RegisterPage.vue";
import SubmitToolPage from "../views/SubmitToolPage.vue";
import UserCenterPage from "../views/UserCenterPage.vue";
import ExamPage from "../views/ExamPage.vue";
import axios from "../utils/axios";
import store from "../store/index";

const routes = [
  {
    path: "/",
    name: "Home",
    component: HomePage,
    meta: { title: "AI工具集市" }, // 添加页面标题
  },
  {
    path: "/user",
    name: "UserCenter",
    component: UserCenterPage,
    meta: {
      requiresAuth: true,
      title: "个人中心 - AI工具集市", // 添加页面标题
    },
  },
  {
    path: "/categories",
    name: "Categories",
    component: CategoriesPage,
    meta: { title: "分类导航 - AI工具集市" }, // 添加页面标题
  },
  {
    path: "/subjects",
    name: "Subjects",
    component: SubjectsPage,
    meta: { title: "学科导航 - AI工具集市" },
  },
  {
    path: "/explore",
    name: "Explore",
    component: ExplorePage,
    meta: { title: "发现工具 - AI工具集市" }, // 添加页面标题
  },
  {
    path: "/rankings",
    name: "Rankings",
    component: RankingsPage,
    meta: { title: "工具排行 - AI工具集市" }, // 添加页面标题
  },
  {
    path: "/submit",
    name: "SubmitTool",
    component: SubmitToolPage,
    meta: { title: "提交工具 - AI工具集市" }, // 添加页面标题
  },
  {
    path: "/exam",
    name: "Exam",
    component: ExamPage,
    meta: { title: "工具审核 -  AI工具集市" }, // 添加页面标题
  },
  {
    path: "/login",
    name: "Login",
    component: LoginPage,
    meta: { title: "登录 - AI工具集市" }, // 添加页面标题
  },
  {
    path: "/register",
    name: "Register",
    component: RegisterPage,
    meta: { title: "注册 - AI工具集市" }, // 添加页面标题
  },
];

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
});

// 导航守卫 - 前置守卫（这里可以保留你后续的鉴权逻辑）
router.beforeEach((to, from, next) => {
  const searchParams = new URLSearchParams(window.location.search);
  var ticket = searchParams.get("ticket") || null;
  if (ticket) {
    axios({
      url: "user/author/login",
      method: "POST",
      data: {
        ticket: ticket,
      },
    }).then((res) => {
      if (res.code == 200) {
        var user = res.data;
        localStorage.setItem("token", user.token);
        store.commit("setUserInfo", user);
      }
      next();
    });
  } else {
    next();
  }
  // 你可以在这里添加登录鉴权逻辑，比如判断 requiresAuth
  // if (to.meta.requiresAuth) {
  //   // 示例：检查用户是否登录
  //   const isLogin = localStorage.getItem("token"); // 假设用localStorage存储登录状态
  //   if (!isLogin) {
  //     // 未登录则跳转到登录页
  //     next({ name: "Login" });
  //   } else {
  //     next();
  //   }
  // } else {
  //   next();
  // }
});

// 导航守卫 - 后置守卫：设置页面标题
router.afterEach((to) => {
  // 设置页面标题，有配置则用配置的，没有则用默认标题
  const defaultTitle = "工具导航平台";
  document.title = to.meta.title || defaultTitle;
});

export default router;
